var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummaryIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0.900391C12.6905 0.900391 16.0996 4.30946 16.0996 8.5C16.0996 12.6905 12.6905 16.0996 8.5 16.0996C4.30946 16.0996 0.900391 12.6905 0.900391 8.5C0.900391 4.30946 4.30946 0.900391 8.5 0.900391ZM4.0127 13.5693C5.20873 14.6295 6.78014 15.2754 8.5 15.2754C12.0973 15.2754 15.0469 12.4564 15.2607 8.91211H8.6709L4.0127 13.5693ZM8.08789 1.73926C4.54356 1.95308 1.72461 4.90269 1.72461 8.5C1.72461 10.2194 2.37009 11.7904 3.42969 12.9863L8.08789 8.3291V1.73926ZM8.91211 8.08789H15.2607C15.0552 4.67983 12.3202 1.94483 8.91211 1.73926V8.08789Z",
    fill: "#BACAD6",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryIcon);
export default __webpack_public_path__ + "static/media/Summary-icon.ee91aa9f0221e4d4fe44cf0bf67a0517.svg";
export { ForwardRef as ReactComponent };